import React, { useEffect } from 'react';
import { LocationBlock } from '../components/LocationBlock';
import { LeadForm } from '../components/LeadForm';
import { CTABand } from '../components/CTABand';
export function Contact() {
  useEffect(() => {
    document.title = 'Contact Us | Storm Taekwondo';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-480">
      {/* Hero */}
      <section className="bg-ink py-20 text-center px-4" data-id="element-481">
        <h1 className="text-5xl md:text-6xl text-white mb-6" data-id="element-482">
          Contact Storm Taekwondo
        </h1>
        <p className="text-xl text-gray-warm max-w-2xl mx-auto" data-id="element-483">
          Have questions? Ready to start? We're here to help.
        </p>
      </section>

      <section className="py-24" data-id="element-484">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-485">
          <div className="grid lg:grid-cols-2 gap-16" data-id="element-486">
            <div data-id="element-487">
              <h2 className="text-3xl text-ink mb-8" data-id="element-488">Get in Touch</h2>
              <div className="mb-12" data-id="element-489">
                <LocationBlock data-id="element-490" />
              </div>

              <div className="bg-paper p-8 rounded-2xl border border-subtle-gray" data-id="element-491">
                <h3 className="text-xl text-ink font-bold mb-4" data-id="element-492">
                  Operating Hours
                </h3>
                <div className="flex flex-col gap-2 text-gray-warm" data-id="element-493">
                  <div className="flex justify-between" data-id="element-494">
                    <span data-id="element-495">Monday - Friday</span>
                    <span className="font-bold text-ink" data-id="element-496">
                      4:00 PM - 8:00 PM
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-497">
                    <span data-id="element-498">Saturday</span>
                    <span className="font-bold text-ink" data-id="element-499">Morning / Events</span>
                  </div>
                  <div className="flex justify-between" data-id="element-500">
                    <span data-id="element-501">Sunday</span>
                    <span className="font-bold text-ink" data-id="element-502">Closed</span>
                  </div>
                </div>
              </div>
            </div>

            <div data-id="element-503">
              <div className="bg-paper p-8 md:p-12 rounded-2xl shadow-xl border border-subtle-gray" data-id="element-504">
                <h2 className="text-3xl text-ink mb-2" data-id="element-505">Send Us a Message</h2>
                <p className="text-gray-warm mb-8" data-id="element-506">
                  Fill out the form below to claim your free week or ask a
                  question. We'll get back to you as soon as possible.
                </p>
                <LeadForm buttonText="Submit Request" data-id="element-507" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <CTABand headline="Ready to Start Your Journey?" copy="Join the Storm Taekwondo family today and discover the benefits of martial arts." data-id="element-508" />
    </div>;
}